import React from "react";
import {BankMovement, BankMovementRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {types} from "../../../../components/form/types";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";

export const BankMovementEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(BankMovementRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getBankMovement(id),
        updater: (bean) => ctrl.saveBankMovement(bean),
        remover: (id) => ctrl.deleteOrDismissBankMovement(id),
        factory: () => ({
            movementDate: new Date().toISOString().split("T")[0],
            movementType: "COBRO",
        } as unknown as BankMovement),
    } as UseFormProps<BankMovement>);

    return (
        <FormContent form={form} title={"Movimiento bancario"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormInput field={"movementDate"} label={"Fecha"} type="date"/>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormSelect
                        field={"movementType"}
                        label={"Tipo"}
                        type={types.bankMovementTypes}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormInput field={"amount"} label={"Importe"} type="number"/>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormInput field={"iban"} label={"IBAN"}/>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormAutocomplete field={"bankAccount"} label={"Cuenta bancaria"} type={types.bankAccounts}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"description"} label={"Descripción"}/>
                </Grid>
            </Grid>
        </FormContent>
    );
};
